import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchSubcategories } from 'Redux/Admin/HabitManager/Subcategories/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { ISubcategory } from 'Redux/Admin/HabitManager/Subcategories/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<ISubcategory> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/habit-manager/subcategories/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    width: 120,
    render: (_, record) => record.category_name,
  },
  {
    title: 'Area',
    dataIndex: 'area',
    key: 'area',
    width: 120,
    render: (_, record) => record.area_name,
  },
  {
    title: 'User Type',
    dataIndex: 'area',
    key: 'area',
    width: 280,
    render: (_, record) => record.area_user_type,
  }
];

const Subcategories = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const category = params.get('category');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchSubcategories);

  useEffect(() => {
    dispatch(fetchSubcategories({ category, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [category, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search...'
    },
    {
      type: 'habit-category-select',
      paramName: 'category',
      placeholder: 'Select category...',
      label: 'Category'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<ISubcategory>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/habit-manager/subcategories/new`}
      filters={filterConfigs}
    />
  );
}

export default Subcategories;
